/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

/**
 * Accessor Handler Decorator
 * Used as decorator - @AccessorHandler
 * @param constructor
 */
function AccessorHandler(constructor) {
    var _a;
    var objectModule = new constructor();
    if (objectModule.getters) {
        Object.keys((_a = objectModule) === null || _a === void 0 ? void 0 : _a.getters).forEach(function (key) {
            var getters = objectModule.getters;
            getters[key]._vuexKey = key;
        });
    }
    if (objectModule.actions) {
        Object.keys(objectModule.actions).forEach(function (key) {
            var actions = objectModule.actions;
            actions[key]._vuexKey = key;
        });
    }
    if (objectModule.mutations) {
        Object.keys(objectModule.mutations).forEach(function (key) {
            var mutations = objectModule.mutations;
            mutations[key]._vuexKey = key;
        });
    }
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.getters = objectModule.getters;
            _this.actions = objectModule.actions;
            _this.mutations = objectModule.mutations;
            return _this;
        }
        return class_1;
    }(constructor));
}

/**
 * Vuex Accessor Wrapper
 */
var AccessorWrapper = /** @class */ (function () {
    function AccessorWrapper(namespace) {
        var _this = this;
        if (namespace === void 0) { namespace = ''; }
        this.namespace = namespace;
        this.accessors = {
            commit: function (handler) { return _this.createAccessor('commit', handler); },
            dispatch: function (handler) { return _this.createAccessor('dispatch', handler); },
            read: function (handler) {
                var key = _this.qualifyKey(handler);
                return function (store) {
                    return store.rootGetters
                        ? store.rootGetters[key] // ActionContext
                        : store.getters[key]; // Store
                };
            }
        };
    }
    AccessorWrapper.prototype.createAccessor = function (operation, handler) {
        var key = this.qualifyKey(handler);
        return function (store, payload) { return store[operation](key, payload, { root: true }); };
    };
    AccessorWrapper.prototype.qualifyKey = function (handler) {
        var key = handler._vuexKey;
        if (!key) {
            console.warn("Vuex handler functions must not be anonymous.\nVuex needs a key by which it identifies a handler.\n      ");
            return '';
        }
        return this.namespace ? this.namespace + "/" + key : key;
    };
    return AccessorWrapper;
}());

export { AccessorHandler, AccessorWrapper };
//# sourceMappingURL=vuex-typescript.es5.js.map
